var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "20360D29-10A5-4172-8F6E-786839A03F9C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.4915834,-3.55271368e-15 C20.7692495,-3.55271368e-15 22.8007447,1.18630882 23.9249247,3.17560334 L23.9249247,3.17560334 L34.3860115,21.2867409 L32.4002337,22.0686263 L22.0927106,4.22241537 C21.343648,2.89660977 19.9990865,2.11003544 18.4915834,2.11003544 C16.9852526,2.11003544 15.6406911,2.89660977 14.8963175,4.21303744 L14.8963175,4.21303744 L2.64990621,25.4153769 C1.91608277,26.7259434 1.9336664,28.299092 2.7026571,29.6131752 C3.45992537,30.9038136 4.79979788,31.6751487 6.28854511,31.6751487 L6.28854511,31.6751487 L30.6946217,31.6751487 C32.1986081,31.6751487 33.5513753,30.8874022 34.3121603,29.56863 C35.0694286,28.2557191 35.0776343,26.7036708 34.3344329,25.4153769 L34.3344329,25.4153769 L33.6674272,24.2607186 L35.6074876,23.4038098 L36.1607858,24.3603592 C37.2873103,26.3086253 37.2791046,28.6495924 36.1396854,30.6236477 C34.9967496,32.6035643 32.9617376,33.7851842 30.6946217,33.7851842 L30.6946217,33.7851842 L6.28854511,33.7851842 C4.0425296,33.7851842 2.02158455,32.6234924 0.882165406,30.6787431 C-0.270148395,28.7117212 -0.294765475,26.3543427 0.815347617,24.3720816 L0.815347617,24.3720816 L13.0641034,3.16622541 C14.1835944,1.18748106 16.2139174,-3.55271368e-15 18.4915834,-3.55271368e-15 Z M19.975351,24.7432689 L19.975351,27.5902373 L16.7289418,27.5902373 L16.7289418,24.7432689 L19.975351,24.7432689 Z M20.0824329,8.83436673 L19.6776112,22.3382145 L16.9992582,22.3382145 L16.5657072,8.83436673 L20.0824329,8.83436673 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1.2---Id-bloqueado",
    transform: "translate(-144.000000, -167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(129.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "",
    fill: "#ffffff",
    fillRule: "nonzero",
    cx: 34.6056352,
    cy: 34.6056352,
    r: 33
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Caution",
    transform: "translate(16.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/Liberty-Blue",
    transform: "translate(0.000000, 0.541667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#d8262f",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#d8262f",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58.583333, -60.125000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 154.166667,
    height: 154.166667
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertError);
export default __webpack_public_path__ + "static/media/alert-error.bb3bc374a295f7b227b53c5b30dab2af.svg";
export { ForwardRef as ReactComponent };